module.exports = __webpack_public_path__ + "assets/ops-d8975048eca61cdae09aa69e5cd3f795.svg";